export function getRandomUUID() {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID()
  }

  throw new Error('Unable to generate UUID: crypto.randomUUID is not available')
}
